import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { cardShadow } from '../constants/Shadows';

const CustomCard = (props) => {
    return (
        <TouchableOpacity testID={props.touchableTestID} onPress={props.onPress} disabled={props.disabled}>
            <View style={styles.cardContainer}>
                {props.children}
            </View>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    cardContainer: {
        backgroundColor: '#fff',
        borderRadius: 8,
        marginVertical: 10,
        ...cardShadow
    },
});

export default CustomCard;